import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveDocumentEditionTokenFailure(key) {
      const res = getState().find(
        (result) => result.documentData?.referenceData?.key === key,
      );

      return res ? res.request.isFailure : false;
    },
    isRetrieveDocumentEditionTokenPending(key) {
      const res = getState().find(
        (result) => result.documentData?.referenceData?.key === key,
      );

      return res ? res.request.isPending : false;
    },
    isRetrieveDocumentEditionTokenSuccess(key) {
      const res = getState().find(
        (result) => result.documentData?.referenceData?.key === key,
      );

      return res ? res.request.isSuccessful : false;
    },
    getToken(key): string {
      const res = getState().find(
        (result) => result.documentData?.referenceData?.key === key,
      );
      return res ? res.token : "";
    },
  };
}

export { createSelector };
